module.exports = __webpack_public_path__ + "img/logo2.a2b4be14.png";